import * as React from 'react';
import * as ToggleGroupPrimitive from '@radix-ui/react-toggle-group';
import { cva, VariantProps } from 'class-variance-authority';

import { toggleVariants } from '../toggle';
import { OmitStylesComponentProps } from '../../types';

export const ToggleGroupContext = React.createContext<
    VariantProps<typeof toggleVariants>
>({
    size: 'default',
    variant: 'default',
});

const ToggleGroupVariants = cva(
    'flex items-center md:justify-center bg-gray-50 overflow-x-auto',
    {
        variants: {
            shape: {
                default:
                    'rounded-full [&::-webkit-scrollbar]:hidden [scrollbar-width:none]',
            },
            justify: {
                center: 'justify-center',
                start: 'justify-start',
            },
        },
        defaultVariants: {
            shape: 'default',
            justify: 'start',
        },
    },
);

export const ToggleGroup = React.forwardRef<
    React.ElementRef<typeof ToggleGroupPrimitive.Root>,
    OmitStylesComponentProps<typeof ToggleGroupPrimitive.Root> &
        VariantProps<typeof toggleVariants> &
        VariantProps<typeof ToggleGroupVariants>
>(({ variant, size, children, ...props }, ref) => (
    <ToggleGroupPrimitive.Root
        ref={ref}
        className={ToggleGroupVariants({ shape: 'default' })}
        {...props}
    >
        <ToggleGroupContext.Provider value={{ variant, size }}>
            {children}
        </ToggleGroupContext.Provider>
    </ToggleGroupPrimitive.Root>
));

ToggleGroup.displayName = ToggleGroupPrimitive.Root.displayName;
